<template>
  <v-container fluid class="pa-0">
    <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
      <v-row no-gutters>
        <v-col cols="12" md="6" lg="4" sm="6" xs="12" class="my-0 py-0">
          <div class="d-flex grow flex-wrap">
            <div class="font-weight-regular headline text-decoration-underline text-capitalize">
              View / Approve Schedule
            </div>
          </div>
        </v-col>
        <v-col>
          <v-card-actions>
            <router-link slot="right" :to="{ name: 'amsSchedulingDashboard' }">
              <v-btn elevation="1" absolute right top>
                <v-icon left>mdi-arrow-left</v-icon>back</v-btn>
            </router-link>
          </v-card-actions>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="3" sm="2" xs="12" v-if="isSuperAdmin">
          <v-autocomplete
            name="id"
            :items="zonalManagerList"
            v-model="zmId"
            item-value="ams_zonalManagers[0].userID"
            item-text="zmName"
            @change="getAcademicManagerList"
          >
            <template v-slot:label> Select Zonal Manager </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" sm="2" xs="12">
          <v-autocomplete
            key="id"
            :items="statusList"
            v-model="statusId"
            item-value="id"
            item-text="name"
          >
            <template v-slot:label> Status </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" sm="2" xs="12">
          <v-autocomplete
            key="id"
            :items="academicManagerList"
            v-model="academicManagerId"
            item-value="amUserId"
            item-text="academicManagerName"
            @change="getRoundByAM(academicManagerId)"
          >
            <template v-slot:label> Academic Manager </template>
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="3" sm="2" xs="12">
          <v-autocomplete
            key="id"
            :items="roundList"
            v-model="roundId"
            item-value="roundId"
            item-text="round"
          >
            <template v-slot:label> Round </template>
          </v-autocomplete>
        </v-col>

        <v-col cols="12" md="2" lg="2" sm="2" xs="12">
          <div class="d-flex justify-end caption">
            <v-btn

              small
              id="apply"
              color="success"
              elevation="1"
              type="submit"
              class="ml-2 mt-5"
              @click="getRondList()"
            >
              <v-icon left size="18"> mdi-text-box-check-outline </v-icon>
              Filter
            </v-btn>
            <v-btn

              small
              elevation="1"
              type="reset"
              @click="resetAll()"
              class="ml-2 mt-5"
            >
              <v-icon left size="18"> mdi-restart</v-icon> Clear
            </v-btn>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="12" lg="12" sm="12" xs="12">
          <v-data-table
            item-key="id"
            :headers="headers"
            :items="viewApprovedSchedule"
          >
            <template v-slot:item.view="{ item }">
              <v-icon color="primary" @click="viewAndApproved(item)">mdi-eye</v-icon>
            </template>
          </v-data-table>
        </v-col>
      </v-row>
    </v-card>
    <v-dialog
      persistent
      v-model="approvedAndRejectPopup"
      max-width="700"
      :active="approvedAndRejectPopup"
      :on-cancel="
        () => {
          ;(approvedAndRejectPopup = false), clearData()
        }
    ">
      <v-card>
        <v-toolbar dark color="darkblue">
          <v-toolbar-title>Schedule For Duration  {{ scheduleDuration }} </v-toolbar-title>
          <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="
                  () => {
                    ;(approvedAndRejectPopup = false), clearData()
                  }
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
          <div>
            <v-data-table
              item-key="id"
              :headers="scheduleHeaders"
              :items="scheduleList"
            ></v-data-table>
          </div>
          <v-btn v-if="status === 'Pending For Approval'"
            class="ml-1 mb-1"
            outlined
            big
            dense
            color="success"
            elevation="0"
            @click="approvedConfirmation(roundID)"
          >
            Approve
          </v-btn>
          <v-btn v-if="status === 'Pending For Approval'"
            class="ml-1 mb-1"
            outlined
            big
            id="apply"
            color="error"
            elevation="1"
            type="submit"
            @click="rejectConfirmation(roundID)"
          >
             Reject
          </v-btn>
        </v-card>
      </v-card>
    </v-dialog>
    <v-dialog
      persistent
      v-model="rejectPopup"
      max-width="700"
      :active="rejectPopup"
      :on-cancel="
        () => {
          ;(rejectPopup = false), clearData()
        }
    ">
      <v-card>
        <v-toolbar dark color="darkblue">
          <v-toolbar-title>Rejection Reason</v-toolbar-title>
          <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
                icon
                dark
                @click="
                  () => {
                    ;(rejectPopup = false), clearData()
                  }
                "
              >
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <v-card class="v-card--material pa-3 ma-2 rounded-lg" elevation="2">
          <v-textarea
            outlined
            placeholder="Max Content 500"
            counter="500"
            clear-icon="mdi-close-circle"
            clearable
            maxlength="500"
            required
            v-model="rejectionDescription"
            :rules="rules"
          ></v-textarea>
        </v-card>
        <v-btn
          class="ml-1 mb-1"
          outlined
          big
          id="apply"
          color="error"
          elevation="1"
          type="submit"
          @click="approvedORrejectSchedule(roundID, 'Rejected')"
          center
        >
          Proceed
        </v-btn>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import stores from '@/stores'
import constants from '@/utils/constants'
import moment from 'moment'

export default {
  name: 'viewApprovedSchedule',
  components: {},
  data () {
    return {
      headers: [
        {
          text: 'Academic Manager ID',
          value: 'amEmailId',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Round',
          value: 'round',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Round Duration',
          value: 'roundDuration',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Status',
          value: 'status',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Action',
          value: 'view',
          sortable: true,
          align: 'center'
        }
      ],
      scheduleHeaders: [
        {
          text: 'Date',
          value: 'auditDate',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Day',
          value: 'dayName',
          sortable: true,
          align: 'center'
        },
        {
          text: 'Franchisee Names',
          value: 'FranchiseeName[0].companyName',
          sortable: true,
          align: 'center'
        }
      ],

      zmUserId: '',
      isSuperAdmin: false,
      viewApprovedSchedule: [],
      approvedAndRejectPopup: false,
      scheduleList: [],
      scheduleDuration: '',
      roundID: '',
      rejectPopup: false,
      rejectionDescription: '',
      rules: ['Description is required'],
      status: '',
      statusList: [
        { id: 'Not Created Yet', name: 'Not Created Yet' },
        { id: 'Pending For Approval', name: 'Pending For Approval' },
        { id: 'Rejected', name: 'Rejected' },
        { id: 'Approved', name: 'Approved' }
      ],
      statusId: '',
      academicManagerList: [],
      academicManagerId: '',
      roundList: [],
      roundId: '',
      zonalManagerList: [],
      zmId: ''
    }
  },
  created: async function () {
    let userStore = stores.user
    console.log(userStore)
    this.isSuperAdmin = userStore.ACL.superAdmin
    if (this.isSuperAdmin === false) {
      if (userStore.roles[0].role === 'AMS_ZonalManager') {
        this.zmUserId = userStore.me.id
      }
    }
    if (!this.isSuperAdmin) {
      await this.getRondList()
      await this.getAcademicManagerList()
    }
    if (this.isSuperAdmin) {
      await this.getZonalmanager()
    }
  },
  methods: {
    getRondList: async function () {
      try {
        if (this.isSuperAdmin) {
          this.zmUserId = this.zmId
        }
        let payload = {}
        if (this.zmUserId) {
          payload.zmUserId = this.zmUserId
        }
        if (this.statusId) {
          payload.status = this.statusId
        }
        if (this.roundId) {
          payload.roundId = this.roundId
        }
        if (this.academicManagerId) {
          payload.amUserId = this.academicManagerId
        }
        const response = await http.post(
          `${constants.API_URL}/api/amsScheduling/createSchedule/getRondList`, payload
        )
        console.log(response.data)
        this.viewApprovedSchedule = response.data
        for (const item of this.viewApprovedSchedule) {
          item.roundDuration = moment(item.startDate).format('DD/MM/YYYY') + ' - ' + moment(item.endDate).format('DD/MM/YYYY')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    viewAndApproved: async function (item) {
      this.status = item.status
      this.approvedAndRejectPopup = true
      this.scheduleDuration = moment(item.startDate).format('DD-MMM-yyyy') + ' - ' + moment(item.endDate).format('DD-MMM-yyyy')
      this.roundID = item.roundId
      try {
        const response = await http.post(
          `${constants.API_URL}/api/amsScheduling/createSchedule/getScheduleList`, {
            'roundId': item.roundId
          }
        )
        console.log(response.data)
        this.scheduleList = response.data
        for (const item of this.scheduleList) {
          item.auditDate = moment(item.auditDate).format('DD/MM/YYYY')
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    clearData () {
      this.approvedAndRejectPopup = false
    },

    approvedConfirmation (roundID) {
      this.$dialog.confirm({
        text: 'Are you sure, you want to approve this ?',
        title: 'Confirm',
        type: 'error',
        actions: {
          false: {
            color: 'error',
            text: 'No',
            handle: () => {
              this.$nextTick(() => {
                return false
              })
            }
          },
          true: {
            color: 'success',
            text: 'Yes',
            handle: async () => {
              this.approvedORrejectSchedule(roundID, 'Approved')
            }
          }
        }
      })
    },
    rejectConfirmation () {
      this.rejectPopup = true
    },
    approvedORrejectSchedule: async function (item, status) {
      try {
        if (this.rejectionDescription.trim() === '' && status === 'Rejected') {
          this.rejectPopup = false
          this.approvedAndRejectPopup = false
          return this.$buefy.dialog.alert({
            type: 'is-info',
            message: 'Description is required',
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        let payload = {}
        if (status === 'Rejected') {
          payload.roundId = item
          payload.status = status
          payload.reason = this.rejectionDescription
        } else if (status === 'Approved') {
          payload.roundId = item
          payload.status = status
        }

        const response = await http.put(
          `${constants.API_URL}/api/amsScheduling/createSchedule/updateRoundStatus`, payload
        )
        if (response.data.status === 200 && status === 'Rejected') {
          this.rejectPopup = false
          this.approvedAndRejectPopup = false
          this.getRondList()
          return this.$buefy.dialog.alert({
            type: 'is-info',
            message: response.data.message,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
        if (response.data.status === 200 && status === 'Approved') {
          this.rejectPopup = false
          this.approvedAndRejectPopup = false
          this.getRondList()
          return this.$buefy.dialog.alert({
            type: 'is-success',
            message: response.data.message,
            hasIcon: true,
            animation: 'zoom-out',
            size: 'is-medium',
            icon: ' mdi-exclamation',
            iconPack: 'mdi',
            ariaRole: 'alertdialog',
            ariaModal: true
          })
        }
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getAcademicManagerList: async function () {
      try {
        if (this.isSuperAdmin) {
          this.zmUserId = this.zmId
          await this.getRondList()
        }
        let payload = {}
        if (this.zmUserId) {
          payload.zmUserId = this.zmUserId
        }
        const response = await http.post(
          `${constants.API_URL}/api/amsScheduling/configuration/firstAudit/getAcademicManagerList`, payload
        )
        this.academicManagerList = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    getRoundByAM: async function (id) {
      try {
        const response = await http.post(
          `${constants.API_URL}/api/amsScheduling/createSchedule/getRondList`,
          {
            'amUserId': id.toString()
          }
        )
        this.roundList = response.data
      } catch (e) {
        const errorMessage = (e && e.response && e.response.data.message) || e.message
        this.$dialog.notify.info(errorMessage, {
          position: 'top-right',
          color: 'error',
          timeout: 2000
        })
      }
    },
    resetAll: function () {
      this.statusId = ''
      this.academicManagerId = ''
      this.roundId = ''
      this.zmId = ''
      if (this.isSuperAdmin === false) {
        this.getRondList()
      }
      if (this.isSuperAdmin) {
        this.viewApprovedSchedule = []
      }
    },
    getZonalmanager: async function () {
      try {
        this.isLoading = true
        const response = await http.get(
          `${constants.API_URL}/api/get-zm-listing`
        )
        this.zonalManagerList = response.data
        this.zonalManagerList = this.zonalManagerList.map((item, index) => {
          if (item.ams_zonalManagers.length > 0) {
            item.zmName = `${
              item.ams_zonalManagers.length
                ? item.ams_zonalManagers[0].user.firstName
                : '-'
            } ${
              item.ams_zonalManagers.length
                ? item.ams_zonalManagers[0].user.lastName
                : ''
            }`
            return item
          }
        })
        this.isLoading = false
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.isLoading = false
        return this.$dialog.error({
          title: 'Error',
          text: errorMessage
        })
      }
    }
  }
}

</script>
